import request from "../config";

const initialState = {
  isFiscalCodeValid: false,
  isFiscalCodeLoading: false,
  isVATValid: false,
  isVATLoading: false,
  isPromocodeValid: false,
  isPromocodeLoading: false,
  promocodeType: "",
  promocodeValue: ""
};

const RESET_ORDERS_STATE = "RESET_ORDERS_STATE";
const RESET_PROMOCODE_STATE = "RESET_PROMOCODE_STATE";

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_ORDERS_STATE:
      return initialState;

    case RESET_PROMOCODE_STATE:
      return {
        ...state,
        isPromocodeValid: false,
        isPromocodeLoading: false,
        promocodeType: "",
        promocodeValue: ""
      };

    default:
      return state;
  }
}

export function verifyVAT(vat) {
  return request({
    method: "GET",
    url: `/vat/${vat}`
  });
}

export function verifyPromocode(promocode, cycle) {
  return request({
    method: "GET",
    url: `/promocodes/${promocode}?cycle=${cycle}`
  });
}

export function verifyFiscalcode(fiscalcode) {
  return request({
    method: "GET",
    url: `/fiscalcode/${fiscalcode}`
  });
}

export function resetOrdersState() {
  return {
    type: RESET_ORDERS_STATE
  };
}

export function resetPromocodeState() {
  return {
    type: RESET_PROMOCODE_STATE
  };
}
